import { CheckoutPage } from "@commerce/shopper/checkout/CheckoutPage";
import { shopperHead } from "@commerce/shopper/meta";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { z } from "zod";
import { buildCsp } from "~/server/csp";
import { getShopperPageFn } from "~/server/shopper";

/**
 * The hosted checkout (B3 task 12): the retailer's look, the checkout the link signs (`t`), and
 * Place order through the signed POST. Public, never framed by another site; the token rides
 * in the URL, so no Referer carries it away.
 */
export const Route = createFileRoute("/c/$orgSlug_/checkout/$checkoutId")({
	staticData: { retailerPage: true },
	validateSearch: z.object({ t: z.string().max(200).default("") }),
	loader: async ({ params }) => {
		const page = await getShopperPageFn({
			data: { orgSlug: params.orgSlug },
		});
		if (!page) {
			throw notFound();
		}
		return page;
	},
	head: ({ loaderData, params }) =>
		shopperHead(loaderData, {
			title: loaderData
				? `Checkout · ${loaderData.retailerName}`
				: "Checkout",
			description: "Review your order and place it.",
			path: `/c/${params.orgSlug}/checkout/${params.checkoutId}`,
		}),
	headers: () => ({
		"content-security-policy": buildCsp({
			frameAncestors: [],
			shopper: true,
		}),
		"referrer-policy": "no-referrer",
	}),
	component: CheckoutRoute,
});

function CheckoutRoute() {
	const page = Route.useLoaderData();
	const { checkoutId } = Route.useParams();
	const { t } = Route.useSearch();
	return <CheckoutPage page={page} checkoutId={checkoutId} token={t} />;
}
